"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWorkerFromFunction = void 0;

var createWorkerFromFunction = function createWorkerFromFunction(fn) {
  var src = "(".concat(fn, ")();");
  var blob = new Blob([src], {
    type: 'application/javascript'
  });
  var url = URL.createObjectURL(blob);
  return new Worker(url);
};

exports.createWorkerFromFunction = createWorkerFromFunction;